export default {"src":"/_next/static/media/location.9955f1a7.svg","height":512,"width":512};